"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSliderWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
var SliderBaseWidget_1 = require("./SliderBaseWidget");
/**
 * This slider has two handles and lets a user select a range of values between those two handles.
 * It allows the user to choose any number from min to max, including decimal numbers.
 */
function RangeSliderWidget(props) {
    return React.createElement(SliderBaseWidget_1.SliderBaseWidget, tslib_1.__assign({}, props, { testId: Declarative_1.makeTestId(props.testId, 'RangeSlider') }));
}
exports.RangeSliderWidget = RangeSliderWidget;
//# sourceMappingURL=RangeSliderWidget.js.map